export default "__VITE_ASSET__baVczflp__"